// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file kitecorp/transferify/storefront/v1/custom_domain.proto (package kitecorp.transferify.storefront.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { EmptySchema, Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import { file_kitecorp_options_v1_options } from "../../../options/v1/options_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file kitecorp/transferify/storefront/v1/custom_domain.proto.
 */
export const file_kitecorp_transferify_storefront_v1_custom_domain: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_empty, file_google_protobuf_timestamp, file_kitecorp_options_v1_options]);

/**
 * The sender's domain and where it stands.
 *
 * @generated from message kitecorp.transferify.storefront.v1.CustomDomain
 */
export type CustomDomain = Message<"kitecorp.transferify.storefront.v1.CustomDomain"> & {
  /**
   * The host, such as share.example.com.
   *
   * @generated from field: string domain = 1;
   */
  domain: string;

  /**
   * Where the domain stands.
   *
   * @generated from field: kitecorp.transferify.storefront.v1.CustomDomain.Status status = 2;
   */
  status: CustomDomain_Status;

  /**
   * The name of the TXT record the sender publishes to prove the domain. Absent for a claimed subdomain, which needs no
   * proof.
   *
   * @generated from field: optional string verification_record_name = 3;
   */
  verificationRecordName?: string | undefined;

  /**
   * The value of that TXT record. Absent for a claimed subdomain, which needs no proof.
   *
   * @generated from field: optional string verification_record_value = 4;
   */
  verificationRecordValue?: string | undefined;

  /**
   * The name of the record that points the host at the edge: the host itself. Absent when this environment has no
   * custom-domain edge.
   *
   * @generated from field: optional string routing_record_name = 5;
   */
  routingRecordName?: string | undefined;

  /**
   * The value of that record, the edge's shared routing endpoint. Absent when this environment has no custom-domain
   * edge.
   *
   * @generated from field: optional string routing_record_value = 6;
   */
  routingRecordValue?: string | undefined;

  /**
   * The state of the edge certificate.
   *
   * @generated from field: kitecorp.transferify.storefront.v1.CustomDomain.CertificateStatus certificate_status = 7;
   */
  certificateStatus: CustomDomain_CertificateStatus;

  /**
   * Whether the edge reports the domain active. Absent when the edge was not asked or could not be read.
   *
   * @generated from field: optional bool edge_domain_active = 8;
   */
  edgeDomainActive?: boolean | undefined;

  /**
   * Why setting the domain up failed. Absent when it did not.
   *
   * @generated from field: optional string provisioning_error = 9;
   */
  provisioningError?: string | undefined;

  /**
   * When the TXT record was found. Absent while the domain is pending.
   *
   * @generated from field: google.protobuf.Timestamp verified_at = 10;
   */
  verifiedAt?: Timestamp | undefined;
};

/**
 * Describes the message kitecorp.transferify.storefront.v1.CustomDomain.
 * Use `create(CustomDomainSchema)` to create a new message.
 */
export const CustomDomainSchema: GenMessage<CustomDomain> = /*@__PURE__*/
  messageDesc(file_kitecorp_transferify_storefront_v1_custom_domain, 0);

/**
 * Where the domain is on the way to serving links.
 *
 * @generated from enum kitecorp.transferify.storefront.v1.CustomDomain.Status
 */
export enum CustomDomain_Status {
  /**
   * No status given.
   *
   * @generated from enum value: STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Registered; the TXT record has not been found yet.
   *
   * @generated from enum value: STATUS_PENDING = 1;
   */
  PENDING = 1,

  /**
   * The TXT record was found; the edge has not taken the domain yet.
   *
   * @generated from enum value: STATUS_VERIFIED = 2;
   */
  VERIFIED = 2,

  /**
   * The edge serves the domain.
   *
   * @generated from enum value: STATUS_ACTIVE = 3;
   */
  ACTIVE = 3,

  /**
   * Setting the domain up at the edge failed; the error says why.
   *
   * @generated from enum value: STATUS_FAILED = 4;
   */
  FAILED = 4,

  /**
   * Switched off.
   *
   * @generated from enum value: STATUS_DISABLED = 5;
   */
  DISABLED = 5,
}

/**
 * Describes the enum kitecorp.transferify.storefront.v1.CustomDomain.Status.
 */
export const CustomDomain_StatusSchema: GenEnum<CustomDomain_Status> = /*@__PURE__*/
  enumDesc(file_kitecorp_transferify_storefront_v1_custom_domain, 0, 0);

/**
 * The state of the certificate the edge issued for the domain.
 *
 * @generated from enum kitecorp.transferify.storefront.v1.CustomDomain.CertificateStatus
 */
export enum CustomDomain_CertificateStatus {
  /**
   * No tenant exists at the edge yet, or the edge could not be read.
   *
   * @generated from enum value: CERTIFICATE_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Waiting for the sender's DNS to prove the domain.
   *
   * @generated from enum value: CERTIFICATE_STATUS_PENDING_VALIDATION = 1;
   */
  PENDING_VALIDATION = 1,

  /**
   * Issued and in use.
   *
   * @generated from enum value: CERTIFICATE_STATUS_ISSUED = 2;
   */
  ISSUED = 2,

  /**
   * Issued, but not in use.
   *
   * @generated from enum value: CERTIFICATE_STATUS_INACTIVE = 3;
   */
  INACTIVE = 3,

  /**
   * Past its end date.
   *
   * @generated from enum value: CERTIFICATE_STATUS_EXPIRED = 4;
   */
  EXPIRED = 4,

  /**
   * The sender's DNS did not prove the domain in time.
   *
   * @generated from enum value: CERTIFICATE_STATUS_VALIDATION_TIMED_OUT = 5;
   */
  VALIDATION_TIMED_OUT = 5,

  /**
   * Revoked.
   *
   * @generated from enum value: CERTIFICATE_STATUS_REVOKED = 6;
   */
  REVOKED = 6,

  /**
   * Issuing failed.
   *
   * @generated from enum value: CERTIFICATE_STATUS_FAILED = 7;
   */
  FAILED = 7,

  /**
   * The edge answered a state this contract does not name.
   *
   * @generated from enum value: CERTIFICATE_STATUS_UNKNOWN = 8;
   */
  UNKNOWN = 8,
}

/**
 * Describes the enum kitecorp.transferify.storefront.v1.CustomDomain.CertificateStatus.
 */
export const CustomDomain_CertificateStatusSchema: GenEnum<CustomDomain_CertificateStatus> = /*@__PURE__*/
  enumDesc(file_kitecorp_transferify_storefront_v1_custom_domain, 0, 1);

/**
 * Asks for the domain of the signed-in account.
 *
 * @generated from message kitecorp.transferify.storefront.v1.GetCustomDomainRequest
 */
export type GetCustomDomainRequest = Message<"kitecorp.transferify.storefront.v1.GetCustomDomainRequest"> & {
};

/**
 * Describes the message kitecorp.transferify.storefront.v1.GetCustomDomainRequest.
 * Use `create(GetCustomDomainRequestSchema)` to create a new message.
 */
export const GetCustomDomainRequestSchema: GenMessage<GetCustomDomainRequest> = /*@__PURE__*/
  messageDesc(file_kitecorp_transferify_storefront_v1_custom_domain, 1);

/**
 * The domain of the signed-in account.
 *
 * @generated from message kitecorp.transferify.storefront.v1.GetCustomDomainResponse
 */
export type GetCustomDomainResponse = Message<"kitecorp.transferify.storefront.v1.GetCustomDomainResponse"> & {
  /**
   * The domain. Absent while the account holds neither a registered host nor a claimed subdomain.
   *
   * @generated from field: kitecorp.transferify.storefront.v1.CustomDomain domain = 1;
   */
  domain?: CustomDomain | undefined;
};

/**
 * Describes the message kitecorp.transferify.storefront.v1.GetCustomDomainResponse.
 * Use `create(GetCustomDomainResponseSchema)` to create a new message.
 */
export const GetCustomDomainResponseSchema: GenMessage<GetCustomDomainResponse> = /*@__PURE__*/
  messageDesc(file_kitecorp_transferify_storefront_v1_custom_domain, 2);

/**
 * Names the host to register.
 *
 * @generated from message kitecorp.transferify.storefront.v1.RegisterCustomDomainRequest
 */
export type RegisterCustomDomainRequest = Message<"kitecorp.transferify.storefront.v1.RegisterCustomDomainRequest"> & {
  /**
   * The host, such as share.example.com.
   *
   * @generated from field: string domain = 1;
   */
  domain: string;
};

/**
 * Describes the message kitecorp.transferify.storefront.v1.RegisterCustomDomainRequest.
 * Use `create(RegisterCustomDomainRequestSchema)` to create a new message.
 */
export const RegisterCustomDomainRequestSchema: GenMessage<RegisterCustomDomainRequest> = /*@__PURE__*/
  messageDesc(file_kitecorp_transferify_storefront_v1_custom_domain, 3);

/**
 * The domain just registered.
 *
 * @generated from message kitecorp.transferify.storefront.v1.RegisterCustomDomainResponse
 */
export type RegisterCustomDomainResponse = Message<"kitecorp.transferify.storefront.v1.RegisterCustomDomainResponse"> & {
  /**
   * The domain, with the records to publish.
   *
   * @generated from field: kitecorp.transferify.storefront.v1.CustomDomain domain = 1;
   */
  domain?: CustomDomain | undefined;
};

/**
 * Describes the message kitecorp.transferify.storefront.v1.RegisterCustomDomainResponse.
 * Use `create(RegisterCustomDomainResponseSchema)` to create a new message.
 */
export const RegisterCustomDomainResponseSchema: GenMessage<RegisterCustomDomainResponse> = /*@__PURE__*/
  messageDesc(file_kitecorp_transferify_storefront_v1_custom_domain, 4);

/**
 * Asks to check the TXT record.
 *
 * @generated from message kitecorp.transferify.storefront.v1.VerifyCustomDomainRequest
 */
export type VerifyCustomDomainRequest = Message<"kitecorp.transferify.storefront.v1.VerifyCustomDomainRequest"> & {
};

/**
 * Describes the message kitecorp.transferify.storefront.v1.VerifyCustomDomainRequest.
 * Use `create(VerifyCustomDomainRequestSchema)` to create a new message.
 */
export const VerifyCustomDomainRequestSchema: GenMessage<VerifyCustomDomainRequest> = /*@__PURE__*/
  messageDesc(file_kitecorp_transferify_storefront_v1_custom_domain, 5);

/**
 * The domain after the check.
 *
 * @generated from message kitecorp.transferify.storefront.v1.VerifyCustomDomainResponse
 */
export type VerifyCustomDomainResponse = Message<"kitecorp.transferify.storefront.v1.VerifyCustomDomainResponse"> & {
  /**
   * The domain as it now stands.
   *
   * @generated from field: kitecorp.transferify.storefront.v1.CustomDomain domain = 1;
   */
  domain?: CustomDomain | undefined;
};

/**
 * Describes the message kitecorp.transferify.storefront.v1.VerifyCustomDomainResponse.
 * Use `create(VerifyCustomDomainResponseSchema)` to create a new message.
 */
export const VerifyCustomDomainResponseSchema: GenMessage<VerifyCustomDomainResponse> = /*@__PURE__*/
  messageDesc(file_kitecorp_transferify_storefront_v1_custom_domain, 6);

/**
 * Asks for a new TXT value.
 *
 * @generated from message kitecorp.transferify.storefront.v1.RotateCustomDomainTokenRequest
 */
export type RotateCustomDomainTokenRequest = Message<"kitecorp.transferify.storefront.v1.RotateCustomDomainTokenRequest"> & {
};

/**
 * Describes the message kitecorp.transferify.storefront.v1.RotateCustomDomainTokenRequest.
 * Use `create(RotateCustomDomainTokenRequestSchema)` to create a new message.
 */
export const RotateCustomDomainTokenRequestSchema: GenMessage<RotateCustomDomainTokenRequest> = /*@__PURE__*/
  messageDesc(file_kitecorp_transferify_storefront_v1_custom_domain, 7);

/**
 * The domain with its new token.
 *
 * @generated from message kitecorp.transferify.storefront.v1.RotateCustomDomainTokenResponse
 */
export type RotateCustomDomainTokenResponse = Message<"kitecorp.transferify.storefront.v1.RotateCustomDomainTokenResponse"> & {
  /**
   * The domain, pending again, with the new value to publish.
   *
   * @generated from field: kitecorp.transferify.storefront.v1.CustomDomain domain = 1;
   */
  domain?: CustomDomain | undefined;
};

/**
 * Describes the message kitecorp.transferify.storefront.v1.RotateCustomDomainTokenResponse.
 * Use `create(RotateCustomDomainTokenResponseSchema)` to create a new message.
 */
export const RotateCustomDomainTokenResponseSchema: GenMessage<RotateCustomDomainTokenResponse> = /*@__PURE__*/
  messageDesc(file_kitecorp_transferify_storefront_v1_custom_domain, 8);

/**
 * Asks to remove the domain.
 *
 * @generated from message kitecorp.transferify.storefront.v1.RemoveCustomDomainRequest
 */
export type RemoveCustomDomainRequest = Message<"kitecorp.transferify.storefront.v1.RemoveCustomDomainRequest"> & {
};

/**
 * Describes the message kitecorp.transferify.storefront.v1.RemoveCustomDomainRequest.
 * Use `create(RemoveCustomDomainRequestSchema)` to create a new message.
 */
export const RemoveCustomDomainRequestSchema: GenMessage<RemoveCustomDomainRequest> = /*@__PURE__*/
  messageDesc(file_kitecorp_transferify_storefront_v1_custom_domain, 9);

/**
 * The host a sender serves download links from, instead of a Transferify address (kitecorp/contracts#74). The sender
 * registers a host, publishes a TXT record to prove they own it, and points the host at the routing record. Each call
 * reads or changes the one domain of the signed-in account.
 *
 * @generated from service kitecorp.transferify.storefront.v1.CustomDomainService
 */
export const CustomDomainService: GenService<{
  /**
   * Reads the domain and its state. The read is also where the server checks the edge and moves a verified domain to
   * active, so the call is left with unknown idempotency and is not sent as a GET.
   *
   * @generated from rpc kitecorp.transferify.storefront.v1.CustomDomainService.GetCustomDomain
   */
  getCustomDomain: {
    methodKind: "unary";
    input: typeof GetCustomDomainRequestSchema;
    output: typeof GetCustomDomainResponseSchema;
  },
  /**
   * Registers a host and answers the records the sender publishes. A host that is malformed, reserved or already held
   * by another account is refused.
   *
   * @generated from rpc kitecorp.transferify.storefront.v1.CustomDomainService.RegisterCustomDomain
   */
  registerCustomDomain: {
    methodKind: "unary";
    input: typeof RegisterCustomDomainRequestSchema;
    output: typeof RegisterCustomDomainResponseSchema;
  },
  /**
   * Looks for the sender's TXT record and, when it is there, verifies the domain and sets the host up at the edge. A
   * record that is absent or different is refused, and the domain stays pending.
   *
   * @generated from rpc kitecorp.transferify.storefront.v1.CustomDomainService.VerifyCustomDomain
   */
  verifyCustomDomain: {
    methodKind: "unary";
    input: typeof VerifyCustomDomainRequestSchema;
    output: typeof VerifyCustomDomainResponseSchema;
  },
  /**
   * Issues a new TXT value, which makes the old one invalid, and puts the domain back to pending. The host stays.
   *
   * @generated from rpc kitecorp.transferify.storefront.v1.CustomDomainService.RotateCustomDomainToken
   */
  rotateCustomDomainToken: {
    methodKind: "unary";
    input: typeof RotateCustomDomainTokenRequestSchema;
    output: typeof RotateCustomDomainTokenResponseSchema;
  },
  /**
   * Removes the domain and takes its tenant down at the edge first. An edge that will not take the tenant down fails
   * the call and the domain stays, so the call can be repeated.
   *
   * @generated from rpc kitecorp.transferify.storefront.v1.CustomDomainService.RemoveCustomDomain
   */
  removeCustomDomain: {
    methodKind: "unary";
    input: typeof RemoveCustomDomainRequestSchema;
    output: typeof EmptySchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_kitecorp_transferify_storefront_v1_custom_domain, 0);

